<template>
  <div class="menu-wrapper">
    <template v-for="item in menu">
      <el-menu-item
        v-if="validatenull(item[childrenKey]) && vaildRoles(item)"
        :index="item[pathKey]"
        @click="open(item)"
        :key="item[labelKey]"
        :class="{ 'is-active': vaildActive(item) }"
      >
        <!-- <el-menu-item v-if="validatenull(item[childrenKey]) && vaildRoles(item)" :index="item[pathKey] && !item.hidden"
        @click="open(item)" :key="item[labelKey]" :class="{ 'is-active': vaildActive(item) }"> -->

        <i class="iconfont icon-jiaowu" :class="item[iconKey]"></i>
        <span slot="title" :alt="item[pathKey]">{{ generateTitle(item) }}</span>
      </el-menu-item>

      <el-menu-item
        v-else-if="!validatenull(item[childrenKey]) && vaildRoles(item)"
        :index="item[pathKey]"
        :key="item[labelKey]"
        @click="open(item)"
        :class="{ 'is-active': vaildActive(item) }"
      >
        <!-- <el-menu-item v-else-if="!validatenull(item[childrenKey]) && vaildRoles(item) && !item.hidden"
        :index="item[pathKey]" :key="item[labelKey]" @click="open(item)" :class="{ 'is-active': vaildActive(item) }"> -->
        <template slot="title">
          <i :class="item[iconKey]"></i>
          <span
            slot="title"
            :class="{ 'el-menu--display': collapse && first }"
            >{{ generateTitle(item) }}</span
          >
          <!-- <span slot="title" :class="{ 'el-menu--display': collapse && first }">{{ generateTitle(item) }}</span> -->
        </template>
      </el-menu-item>
    </template>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { isURL, validatenull } from "@/utils/validate";
import config from "./config.js";
export default {
  name: "sidebarItem",

  props: {
    nowTagValue: { type: String, default: null },
    menu: {
      type: Array
    },
    propscreen: {
      type: Number,
      default: -1
    },
    first: {
      type: Boolean,
      default: false
    },
    props: {
      type: Object,
      default: () => {
        return {};
      }
    },
    collapse: {
      type: Boolean
    }
  },

  data() {
    return {
      config: config
    };
  },

  computed: {
    ...mapGetters(["roles"]),
    labelKey() {
      return this.props.label || this.config.propsDefault.label;
    },
    pathKey() {
      return this.props.path || this.config.propsDefault.path;
    },
    iconKey() {
      return this.props.icon || this.config.propsDefault.icon;
    },
    childrenKey() {
      return this.props.children || this.config.propsDefault.children;
    },
    isOpenKey() {
      return this.props.isOpen || this.config.propsDefault.isOpen;
    }
  },

  watch: {
    $route(val) {
      console.log(val, "ddddddddddddaa1");
      // this.getBreadcrumb();
    }
  },

  created() {},

  mounted() {
    console.log(this.menu, "menumenu");
    if (this.menu.length != 0) {
      // this.validIsOpen(this.menu[0])
    }
  },

  methods: {
    generateTitle1: (title, key) => {
      if (!key) return title;
      const hasKey = this.$vue.$te("route." + key);
      console.log(key, "keykeykey");
      if (hasKey) {
        const translatedTitle = this.$vue.$t("route." + key);
        return translatedTitle;
      }
      return title;
    },
    generateTitle(item) {
      if (item) {
        return this.generateTitle1(item[this.labelKey], (item.meta || {}).i18n);
      }
    },
    vaildActive(item) {
      // console.log(item, "itemitem");
      const groupFlag = (item["group"] || []).some(ele => {
        if (ele != "/") {
          console.log(this.$route.path, "groupFlag-ele3");
          return this.$route.path.includes(ele);
        } else {
          // console.log(ele, "groupFlag-ele2");
          return false;
        }
      });
      var is = this.nowTagValue === item[this.pathKey] || groupFlag; //激活默认
      console.log("点击菜单");
      console.log("===");
      console.log(groupFlag, "groupFlag");
      console.log("===");
      console.log(is, "is");
      console.log(item["group"], `item["group"]`);
      console.log(this.nowTagValue, "this.nowTagValue");
      console.log(item[this.pathKey], "item[this.pathKey]");

      if (is) {
        console.log(is, "isxxxxxxx");
        this.getMenu(item);
      }
      return this.nowTagValue === item[this.pathKey] || groupFlag;
    },
    vaildRoles(item) {
      item.meta = item.meta || {};
      return item.meta.roles ? item.meta.roles.includes(this.roles) : true;
    },
    validatenull(val) {
      return validatenull(val);
    },
    validIsOpen(item) {
      if (item[this.isOpenKey] && isURL(item[this.pathKey])) {
        return true;
      }
      return true;
    },
    getMenu(v) {
      console.log(v, "左侧菜单已经被点击");
      this.$nextTick(function() {
        var arr = [];
        if (v && v.children) {
          arr = v.children;
        }
        console.log(arr, "arrarrarr");
        this.BUS.$emit("menuList", arr);
      });
    },

    //点击左侧菜单
    open(item) {
      // console.log(item[this.pathKey], "点击左侧菜单1");
      // console.log("===============11");
      // console.log(item);
      this.$router.push({ path: item[this.pathKey] });
      if (this.screen <= 1) this.$store.commit("SET_COLLAPSE");
      this.getMenu(item);
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/sidebar/sidebarItem.vue